import moment from "moment";
import RunSVG from "assets/img/run.svg";
import RideSVG from "assets/img/ride.svg";
import SwimSVG from "assets/img/swim.svg";
import HikeSVG from "assets/img/hike.svg";
import WorkoutSVG from "assets/img/workout.svg";
import TriathlonSVG from "assets/img/triathlon.svg";

export const APP_NAME = "Strava Mate";
export const APP_VERSION = process.env.REACT_APP_VERSION || "";
export const DEBUG = process.env.REACT_APP_DEBUG || "false";
export const API_URL = process.env.REACT_APP_API_URL || "no-api";
export const API_URL_MOCK = process.env.REACT_APP_API_URL_MOCK || "no-api";
export const AUTH_URL = process.env.REACT_APP_AUTH_URL || "no-api";
export const WS_URL = process.env.REACT_APP_WS_URL || "no-api";
export const CANCEL_REQUEST = "CANCEL_REQUEST";
export const TOKEN_NAME = "APP_TOKEN";
export const REFRESH_TOKEN_NAME = "APP_REFRESH_TOKEN";
export const BASE_NAME = process.env.REACT_APP_BASE_NAME || "";

export const BIDDING_STATUS_TYPE = [
  { label: "On Going", value: 0 },
  { label: "Completed", value: 1 },
];

export const VIEW_TYPE = {
  Week: "Week",
  Month: "Month",
  Year: "Year"
};

export const SPORT_TYPE = {
  Run: "Run",
  Ride: "Ride",
  Swim: "Swim",
  Hike: "Hike",
  Walk: "Walk",
  Workout: "Workout",
  All: "All",
};

export const SPORT_ICONS = {
  Run: RunSVG,
  Ride: RideSVG,
  Swim: SwimSVG,
  Hike: HikeSVG,
  Workout: WorkoutSVG,
  All: TriathlonSVG
};

export const ACTION_TYPE = {
  view: "view",
  addedit: "addedit",
  delete: "delete",
  approve: "approve",
  admin: "admin",
};

export const STATS_TYPE = {
  Calories: "kcal",
  Heartrate: "bpm",
  Power: "W",
  Temp: "°C",
  Elevation: "m",
  Cadence: "spm",
  RideCadence: "rpm",
};

export const FILTER_DATE_RANGES = {
  "Last 7 days": [
    moment().startOf("day").add(-6, "days"),
    moment().endOf("day"),
  ],
  "Last 14 days": [
    moment().startOf("day").add(-13, "days"),
    moment().endOf("day"),
  ],
  "Last 21 days": [
    moment().startOf("day").add(-20, "days"),
    moment().endOf("day"),
  ],
  "Last 30 days": [
    moment().startOf("day").add(-29, "days"),
    moment().endOf("day"),
  ],
};

export const TIME_SELECT_OPTS = [
  { value: "last-month", label: "Last month" },
  { value: "last-3-months", label: "Last 3 months" },
  { value: "last-6-months", label: "Last 6 months" },
];

export const DATE_TIME_FORMAT = {
  DATETIMELONG: "MMM DD, YYYY h:mm:ss A",
  DATETIME: "MMM DD, h:mm A",
  WEEKDAY: "ddd DD",
  WEEKDAYFULL: "ddd DD MMMM YYYY",
  WEEKDAYLONG: "ddd DD MMMM",
  WEEKDAYTIME: "ddd DD, h:mm A",
  WEEKDAYTIMELONG: "ddd DD MMMM, h:mm A",
  WEEKDAYTIMEFULL: "ddd DD MMMM YYYY, h:mm A",
  DATE: "DD/MM/YYYY",
  DATELONG: "DD MMMM YYYY",
  TIME: "hh:mm A",
  DBDATE: "YYYY-MM-DD",
  DAY: "DD",
  MONTH: "MMMM",
  MONTHLONG: "MMMM YYYY",
  YEAR: "YYYY",
};

export const FILE_TYPE = {
  xls: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
  pdf: "pdf",
  csv: "text/csv;charset=utf-8",
};

export const CHART_COLOR_OPTION = {
  Time: "#98ded9",
  Distance: "#34b6f0",
  Pace: "#bce5f8",
  Elevation: "#6abc35",
  Power: "#ffa940",
  HeartRate: "#ffb4c2",
  Calories: "#ffb4c2",
  DaysActive: "#ffa940",
  Default: "#fc5200"
};

export const LINE_CHART_OPTION = {
  tooltip: {
    trigger: "axis",
    axisPointer: {
      type: "shadow",
    },
  },
  legend: {
    right: 0,
  },
  grid: {
    top: "30px",
    left: "1%",
    right: "30px",
    bottom: "0px",
    containLabel: true,
  },
  xAxis: {
    type: "category",
    boundaryGap: false,
    data: [],
    axisLine: {
      lineStyle: {
        color: "#000",
      },
    },
    axisTick: {
      show: false,
      lineStyle: {
        color: "#000",
      },
    },
    axisLabel: {
      show: true,
      showMaxLabel: true,
      rotate: 90,
      formatter: function (value, index) {
        // Formatted to be month/day; display year only in the first label
        return moment(value).format(DATE_TIME_FORMAT.WEEKDAY);
      },
      rich: {
        annotation: {
          color: "red",
          fontWeight: "bold",
        },
      },
      color: "#000",
    },
    color: "#000",
  },
  yAxis: {
    type: "value",
    splitLine: {
      show: false,
      lineStyle: {
        color: "#EAF0F4",
      },
    },
    axisLine: {
      show: true,
      lineStyle: {
        color: "#000",
      },
    },
    axisTick: {
      show: false,
      lineStyle: {
        color: "#000",
      },
    },
    axisLabel: {
      show: true,
      color: "#000",
    },
    color: "#000",
  },
  series: [
    {
      name: "",
      type: "line",
      smooth: false,
      itemStyle: {
        color: "#D2207F",
      },
      data: [],
      markLine: {
        // data: [{
        //     name: 'Horizontal line with Y value at 180',
        //     yAxis: 180
        // }],
        lineStyle: {
          color: "#707070",
          type: "solid",
        },
        label: {
          show: true,
          position: "insideStartTop",
        },
        symbol: "none",
        tooltip: {
          trigger: "axis",
        },
      },
    },
    {
      name: "",
      type: "line",
      smooth: false,
      itemStyle: {
        color: "#3979EF",
      },
      data: [],
    },
  ],
};

// export const PIE_CHART_OPTION = {
//     tooltip: {
//       trigger: "item",
//       formatter: "<b>{a}</b> <br/><b>{b}</b> <br/> Value: {c}"
//     },
//     legend: {
//       type: "scroll",
//       orient: "vertical",
//       right: 0,
//       top: 20,
//       bottom: 20
//     },
//     series: [
//       {
//         name: "",
//         type: "pie",
//         radius: ["0", "80%"],
//         avoidLabelOverlap: false,
//         data: [],
//         legendHoverLink: false,
//         label: {
//           show: false
//         },
//         left: "-40%",
//         selectedMode: "single"
//       }
//     ],
//     color: ['#2E8A63', '#91CC75']
//   }

export const PIE_CHART_OPTION = {
  tooltip: {
    trigger: "item",
  },
  legend: {
    // top: '50%',
    right: 0,
    top: 20,
    bottom: 20,
    orient: "vertical",

    itemWidth: 15,
    textStyle: {
      width: 30,
      overflow: "break",
    },
  },
  series: [
    {
      name: "",
      type: "pie",
      radius: ["40%", "70%"],
      avoidLabelOverlap: false,
      label: {
        show: true,
        formatter: "{d} %",
        position: "outer",
        // alignTo: 'edge',
        // edgeDistance: '250%'
      },
      emphasis: {
        label: {
          show: true,
          fontSize: "12",
          fontWeight: "bold",
        },
        labelLine: {
          show: true,
        },
      },
      labelLine: {
        show: true,
      },
      center: ["35%", "50%"],
      data: [],
    },
  ],
  color: ["#2E8A63", "#91CC75", "#002369"],
};

export const BAR_CHART_OPTION = {
  color: ["#00854F", "#002369", "#5790D2", "#EA6412"],
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: "shadow",
    },
    textStyle: {
      fontSize: 12
    },
    formatter: function (values) {
      let htmlTooltip = `${moment(values[0].name).format(DATE_TIME_FORMAT.WEEKDAYLONG)}<br />`;
      for (let s of values) {
        if (s.seriesName === "Distance") htmlTooltip += `<span style="background-color: ${CHART_COLOR_OPTION.Distance}; margin-right: 8px;">&nbsp;</span>${s.seriesName}: ${(s.data.value / 1000).toFixed(1)} km<br />`;
        else if (s.seriesName === "Speed" || s.seriesName === "Pace") htmlTooltip += `<span style="background-color: ${CHART_COLOR_OPTION.Pace}; margin-right: 8px;">&nbsp;</span>${s.seriesName}: ${s.data.pace}<br />`;
        else if (s.seriesName === "Elevation") htmlTooltip += `<span style="background-color: ${CHART_COLOR_OPTION.Elevation}; margin-right: 8px;">&nbsp;</span>${s.seriesName}: ${s.data.value} m<br />`;
        else if (s.seriesName === "Power") htmlTooltip += `<span style="background-color: ${CHART_COLOR_OPTION.Power}; margin-right: 8px;">&nbsp;</span>${s.seriesName}: ${s.data.value} watts<br />`;
        else if (s.seriesName === "Days Active") htmlTooltip += `<span style="background-color: ${CHART_COLOR_OPTION.DaysActive}; margin-right: 8px;">&nbsp;</span>${s.seriesName}: ${s.data.value} days<br />`;
        else if (s.seriesName === "HR") htmlTooltip += `<span style="background-color: ${CHART_COLOR_OPTION.HeartRate}; margin-right: 8px;">&nbsp;</span>${s.seriesName}: ${s.data.value} bpm`;
      }
      return htmlTooltip;
    }
  },
  legend: {
    show: true,
    bottom: 0,
    itemGap: 15,
    itemWidth: 3,
    itemHeight: 14,
    icon: 'rect',
    textStyle: {
      fontSize: 12,
      padding: [0, 0, 0, 1]
    }
  },
  grid: {
    top: "5px",
    left: "0px",
    right: "0px",
    bottom: "35px",
    containLabel: false,
  },
  // toolbox: {
  //   feature: {
  //     saveAsImage: {} // save chart as image
  //   }
  // },
  xAxis: {
    show: false,
    type: "category",
    boundaryGap: true, // data area gap from both edges
    data: [],
    axisLabel: {
      show: true,
      rotate: 0,
      formatter: function (value, index) {
        // Formatted to be month/day; display year only in the first label
        return moment(value).format(DATE_TIME_FORMAT.WEEKDAY);
      },
    },
    axisLine: {
      show: false,
      lineStyle: {
        color: "#000",
      },
    },
    axisTick: {
      show: false,
      lineStyle: {
        color: "#000",
      },
    },
  },
  yAxis: [
  {
    show: false,
    type: "value",
    splitLine: {
      show: false,
      lineStyle: {
        color: "#EAF0F4",
      },
    },
    axisLine: {
      show: false,
      lineStyle: {
        color: "#000",
      },
    },
    axisTick: {
      show: false,
      lineStyle: {
        color: "#000",
      },
    },
    axisLabel: {
      rotate: 0
    }
  }],
  series: [
    {
      name: "",
      type: 'bar',
      smooth: true,
      // stack: 'Total',
      barWidth: '5',
      itemStyle: {
        color: CHART_COLOR_OPTION.Elevation,
        opacity: 1
      },
      // emphasis: {
      //   itemStyle: {
      //     color: "#b5e8b5",
      //     opacity: 1
      //   },
      //   // focus: 'series' // highlight series on series/legend hover event
      // },
      data: [],
    },
  ],
};

export const AREA_CHART_OPTION = {
  color: ["#00854F", "#002369", "#5790D2", "#EA6412"],
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: "shadow",
    },
    textStyle: {
      fontSize: 12
    },
    formatter: function (values) {
      let htmlTooltip = `${moment(values[0].name).format(DATE_TIME_FORMAT.WEEKDAYLONG)}<br />`;
      for (let s of values) {
        if (s.seriesName === "Time") htmlTooltip += `<span style="background-color: ${CHART_COLOR_OPTION.Time}; margin-right: 8px;">&nbsp;</span>${s.seriesName}: ${(s.data.value / 60).toFixed(0)} mins<br />`;
        else if (s.seriesName === "Distance") htmlTooltip += `<span style="background-color: ${CHART_COLOR_OPTION.Distance}; margin-right: 8px;">&nbsp;</span>${s.seriesName}: ${(s.data.value / 1000).toFixed(1)} km<br />`;
        else if (s.seriesName === "Speed" || s.seriesName === "Pace") htmlTooltip += `<span style="background-color: ${CHART_COLOR_OPTION.Pace}; margin-right: 8px;">&nbsp;</span>${s.seriesName}: ${s.data.pace}<br />`;
        else if (s.seriesName === "Elevation") htmlTooltip += `<span style="background-color: ${CHART_COLOR_OPTION.Elevation}; margin-right: 8px;">&nbsp;</span>${s.seriesName}: ${s.data.value} m<br />`;
        else if (s.seriesName === "Power") htmlTooltip += `<span style="background-color: ${CHART_COLOR_OPTION.Power}; margin-right: 8px;">&nbsp;</span>${s.seriesName}: ${s.data.value} watts<br />`;
        else if (s.seriesName === "Days Active") htmlTooltip += `<span style="background-color: ${CHART_COLOR_OPTION.DaysActive}; margin-right: 8px;">&nbsp;</span>${s.seriesName}: ${s.data.value} days<br />`;
        else if (s.seriesName === "HR") htmlTooltip += `<span style="background-color: ${CHART_COLOR_OPTION.HeartRate}; margin-right: 8px;">&nbsp;</span>${s.seriesName}: ${s.data.value} bpm`;
      }
      return htmlTooltip;
    }
  },
  legend: {
    show: true,
    bottom: 0,
    itemGap: 15,
    itemWidth: 3,
    itemHeight: 14,
    icon: 'rect',
    textStyle: {
      fontSize: 12,
      padding: [0, 0, 0, 1]
    }
  },
  grid: {
    top: "5px",
    left: "0px",
    right: "0px",
    bottom: "35px",
    containLabel: false,
  },
  // toolbox: {
  //   feature: {
  //     saveAsImage: {} // save chart as image
  //   }
  // },
  xAxis: {
    show: false,
    type: "category",
    boundaryGap: true, // data area gap from both edges
    data: [],
    axisLabel: {
      show: true,
      rotate: 0,
      formatter: function (value, index) {
        // Formatted to be month/day; display year only in the first label
        return moment(value).format(DATE_TIME_FORMAT.WEEKDAY);
      },
    },
    axisLine: {
      show: false,
      lineStyle: {
        color: "#000",
      },
    },
    axisTick: {
      show: false,
      lineStyle: {
        color: "#000",
      },
    },
  },
  yAxis: [
  {
    show: false,
    type: "value",
    name: 'Time',
    splitLine: {
      show: false,
      lineStyle: {
        color: "#EAF0F4",
      },
    },
    axisLine: {
      show: false,
      lineStyle: {
        color: "#000",
      },
    },
    axisTick: {
      show: false,
      lineStyle: {
        color: "#000",
      },
    },
    axisLabel: {
      rotate: 0
    }
  },
  {
    show: false,
    type: "value",
    name: 'Distance',
    splitLine: {
      show: false,
      lineStyle: {
        color: "#EAF0F4",
      },
    },
    axisLine: {
      show: false,
      lineStyle: {
        color: "#000",
      },
    },
    axisTick: {
      show: false,
      lineStyle: {
        color: "#000",
      },
    },
    axisLabel: {
      rotate: 0
    }
  },
  {
    show: false,
    type: 'value',
    name: 'Elevation',
    // min: 0,
    // max: 25,
    // interval: 5,
    axisLabel: {
      formatter: '{value} m'
    }
  },
  {
    show: false,
    type: 'value',
    name: 'Pace',
    // min: 0,
    // max: 25,
    // interval: 5,
    axisLabel: {
      formatter: '{value}'
    }
  },
  {
    show: false,
    type: 'value',
    name: 'Power',
    // min: 0,
    // max: 25,
    // interval: 5,
    axisLabel: {
      formatter: '{value} watts'
    }
  },
  {
    show: false,
    type: 'value',
    name: 'Heart Rate',
    // min: 0,
    // max: 25,
    // interval: 5,
    axisLabel: {
      formatter: '{value} bpm'
    }
  }],
  series: [
    {
      name: "",
      type: 'line',
      smooth: true,
      // stack: 'Total',
      // areaStyle: {},
      itemStyle: {
        color: CHART_COLOR_OPTION.Time,
        opacity: 1
      },
      // lineStyle: {color: '#00854F'},
      // emphasis: {
      //   itemStyle: {
      //     color: "#000",
      //     opacity: 1
      //   },
      //   // focus: 'series' // highlight series on series/legend hover event
      // },
      yAxisIndex: 0,
      data: [],
    },
    {
      name: "",
      type: 'line',
      smooth: true,
      // stack: 'Total',
      // areaStyle: {},
      itemStyle: {
        color: CHART_COLOR_OPTION.Distance,
        opacity: 1
      },
      // lineStyle: {color: '#00854F'},
      // emphasis: {
      //   itemStyle: {
      //     color: "#000",
      //     opacity: 1
      //   },
      //   // focus: 'series' // highlight series on series/legend hover event
      // },
      yAxisIndex: 1,
      data: [],
    },
    {
      name: "",
      type: 'bar',
      smooth: true,
      // stack: 'Total',
      barWidth: '5',
      itemStyle: {
        color: CHART_COLOR_OPTION.Elevation,
        opacity: 1
      },
      // emphasis: {
      //   itemStyle: {
      //     color: "#b5e8b5",
      //     opacity: 1
      //   },
      //   // focus: 'series' // highlight series on series/legend hover event
      // },
      yAxisIndex: 2,
      data: [],
    },
    {
      name: "",
      type: 'bar',
      smooth: true,
      // stack: 'Energy',
      barWidth: '5',
      itemStyle: {
        color: CHART_COLOR_OPTION.Pace,
        opacity: 1
      },
      // emphasis: {
      //   itemStyle: {
      //     color: "#34b6f0",
      //     opacity: 1
      //   },
      //   // focus: 'series' // highlight series on series/legend hover event
      // },
      yAxisIndex: 3,
      data: [],
    },
    {
      name: "",
      type: 'bar',
      smooth: true,
      // stack: 'Energy',
      barWidth: '5',
      itemStyle: {
        color: CHART_COLOR_OPTION.Power,
        opacity: 1
      },
      // emphasis: {
      //   itemStyle: {
      //     color: "#34b6f0",
      //     opacity: 1
      //   },
      //   // focus: 'series' // highlight series on series/legend hover event
      // },
      yAxisIndex: 4,
      data: [],
    },
    {
      name: "",
      type: 'line',
      smooth: true,
      // stack: 'Total',
      // areaStyle: {},
      lineStyle: {
        type: "dotted" //dotted | dashed
      },
      itemStyle: {
        color: CHART_COLOR_OPTION.HeartRate,
        opacity: 1
      },
      // emphasis: {
      //   itemStyle: {
      //     color: "#34b6f0",
      //     opacity: 1
      //   },
      //   // focus: 'series' // highlight series on series/legend hover event
      // },
      yAxisIndex: 5,
      data: [],
    },
  ],
};